<div class="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-md animate-fade-in"
    (click)="onCancel()">

    <div class="bg-white dark:bg-slate-800 w-full max-w-4xl max-h-[90vh] rounded-[2.5rem] shadow-2xl flex flex-col relative animate-fade-in-up z-[110] overflow-hidden"
        (click)="onClickInsideModal($event)">

        <!-- Header -->
        <div class="px-8 py-6 border-b border-slate-100 flex items-center justify-between bg-white sticky top-0 z-20">
            <div class="flex items-center gap-4">
                <div class="w-12 h-12 rounded-2xl bg-amber-50 flex items-center justify-center text-amber-500">
                    <span class="material-icons text-2xl">apartment</span>
                </div>
                <div>
                    <h2 class="text-xl font-black text-slate-800 tracking-tight">
                        {{ data ? 'แก้ไขชั้นที่ตั้งบริษัทผู้เช่า' : 'เพิ่มชั้นที่ตั้งบริษัทผู้เช่า' }}
                    </h2>
                    <p class="text-[10px] font-black text-slate-400 uppercase tracking-widest mt-0.5">Floor & Tenant
                        Location Information</p>
                </div>
            </div>

            <div class="flex items-center gap-3">
                <button (click)="onCancel()"
                    class="px-6 py-2.5 rounded-xl text-slate-500 font-bold hover:bg-slate-100 transition-all text-xs">ยกเลิก</button>
                <button (click)="onSave()" [disabled]="isLoading"
                    class="px-8 py-2.5 bg-amber-400 hover:bg-amber-500 text-white font-black rounded-xl shadow-lg hover:-translate-y-0.5 transition-all flex items-center gap-2 text-xs">
                    <span *ngIf="isLoading"
                        class="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span>
                    บันทึกข้อมูล
                </button>
            </div>
        </div>

        <!-- Form Area (2-Column Grid) -->
        <div class="flex-1 overflow-y-auto p-12 custom-scrollbar">
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-x-16 gap-y-10">

                <!-- Left Column -->
                <div class="space-y-8">
                    <h3
                        class="text-xs font-black text-amber-600 uppercase tracking-widest border-l-4 border-amber-400 pl-3">
                        ข้อมูลพื้นฐาน</h3>

                    <div class="space-y-5">
                        <div>
                            <label
                                class="text-[11px] font-black text-slate-400 uppercase tracking-widest pl-1 mb-1.5 block">ชื่อชั้น
                                (Name)</label>
                            <input type="text" [(ngModel)]="form.name" placeholder="เช่น ชั้น 1"
                                class="w-full h-11 px-4 bg-slate-50 border border-slate-100 rounded-xl text-sm font-bold focus:bg-white focus:ring-4 focus:ring-amber-50 transition-all outline-none">
                        </div>

                        <div>
                            <label
                                class="text-[11px] font-black text-slate-400 uppercase tracking-widest pl-1 mb-1.5 block">ประเภทที่จอดรถ
                                (Parking Type)</label>
                            <div class="relative">
                                <div class="relative flex items-center">
                                    <input type="text" [(ngModel)]="searchParkingTypeText"
                                        placeholder="เลือกหรือพิมพ์ค้นหาประเภทรถ..."
                                        (focus)="onInputFocus('parkingType')"
                                        (click)="onInputFocus('parkingType'); $event.stopPropagation()"
                                        (blur)="closeDropdowns()"
                                        class="w-full h-11 px-4 pr-10 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 rounded-xl text-sm font-bold text-slate-700 dark:text-slate-200 focus:bg-white dark:focus:bg-slate-800 focus:ring-4 focus:ring-amber-50 dark:focus:ring-amber-900/30 outline-none transition-all placeholder:font-normal placeholder:text-slate-400">
                                    <span
                                        class="material-icons text-slate-400 text-sm absolute right-4 transition-transform pointer-events-none cursor-pointer"
                                        [class.rotate-180]="openDropdown==='parkingType'">expand_more</span>
                                </div>
                                <div *ngIf="openDropdown === 'parkingType'" (mousedown)="$event.preventDefault()"
                                    class="absolute top-full left-0 right-0 mt-2 z-30 bg-white rounded-xl shadow-xl border border-slate-100 py-2 max-h-48 overflow-y-auto animate-fade-in-up">
                                    <div *ngIf="filteredParkingTypes.length === 0"
                                        class="px-4 py-3 text-sm text-slate-400 text-center font-bold">
                                        ไม่พบข้อมูลที่ค้นหา</div>
                                    <div *ngFor="let t of filteredParkingTypes" (click)="selectOption('parkingType', t)"
                                        class="px-4 py-2.5 text-sm font-bold hover:bg-amber-50 hover:text-amber-600 cursor-pointer transition-all">
                                        {{ t }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="grid grid-cols-2 gap-4">
                            <div>
                                <label
                                    class="text-[11px] font-black text-slate-400 uppercase tracking-widest pl-1 mb-1.5 block">จำนวนห้อง
                                    (Lots)</label>
                                <input type="number" [(ngModel)]="form.lots"
                                    class="w-full h-11 px-4 bg-slate-50 border border-slate-100 rounded-xl text-sm font-bold focus:bg-white transition-all outline-none">
                            </div>
                            <div class="flex flex-col justify-end">
                                <div (click)="form.isOnline = !form.isOnline"
                                    class="h-11 px-4 bg-slate-50 border border-slate-100 rounded-xl flex items-center gap-3 cursor-pointer select-none">
                                    <div class="w-6 h-6 rounded-lg flex items-center justify-center transition-all border"
                                        [ngClass]="form.isOnline ? 'bg-amber-500 border-amber-500 text-white' : 'bg-white border-slate-200 text-transparent'">
                                        <span class="material-icons text-sm font-black">check</span>
                                    </div>
                                    <span
                                        class="text-[11px] font-black text-slate-500 uppercase tracking-widest">เปิดใช้งาน
                                        (Online)</span>
                                </div>
                            </div>
                        </div>

                        <div>
                            <label
                                class="text-[11px] font-black text-slate-400 uppercase tracking-widest pl-1 mb-1.5 block">พื้นที่ให้บริการ
                                (Area)</label>
                            <div class="relative">
                                <div class="relative flex items-center">
                                    <input type="text" [(ngModel)]="searchSiteText"
                                        placeholder="เลือกหรือพิมพ์ค้นหาพื้นที่..." (focus)="onInputFocus('site')"
                                        (click)="onInputFocus('site'); $event.stopPropagation()"
                                        (blur)="closeDropdowns()"
                                        class="w-full h-11 px-4 pr-10 bg-amber-50/30 border border-amber-100/50 rounded-xl text-sm font-bold text-amber-600 focus:bg-white focus:ring-4 focus:ring-amber-50 outline-none transition-all placeholder:font-normal placeholder:text-amber-400/70">
                                    <span
                                        class="material-icons text-amber-400 text-sm absolute right-4 transition-transform pointer-events-none cursor-pointer"
                                        [class.rotate-180]="openDropdown==='site'">expand_more</span>
                                </div>
                                <div *ngIf="openDropdown === 'site'" (mousedown)="$event.preventDefault()"
                                    class="absolute top-full left-0 right-0 mt-2 z-30 bg-white rounded-xl shadow-xl border border-slate-100 py-2 max-h-[200px] overflow-y-auto animate-fade-in-up">
                                    <div *ngIf="filteredSites.length === 0"
                                        class="px-4 py-3 text-sm text-slate-400 text-center font-bold">
                                        ไม่พบข้อมูลที่ค้นหา</div>
                                    <div *ngFor="let s of filteredSites" (click)="selectOption('serviceArea', s.name)"
                                        class="px-4 py-2.5 text-sm font-bold hover:bg-amber-50 hover:text-amber-600 transition-all cursor-pointer">
                                        {{ s.name }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Right Column (Images) -->
                <div class="space-y-8">
                    <h3
                        class="text-xs font-black text-amber-600 uppercase tracking-widest border-l-4 border-amber-400 pl-3">
                        รูปภาพประกอบ</h3>

                    <div class="space-y-6">
                        <div *ngFor="let i of [1,2,3]" class="flex items-center gap-4 group">
                            <div
                                class="w-24 h-24 bg-slate-50 border-2 border-dashed border-slate-200 rounded-2xl flex items-center justify-center overflow-hidden transition-all group-hover:border-amber-300">
                                <img *ngIf="form['image'+i]" [src]="form['image'+i]" class="w-full h-full object-cover">
                                <span *ngIf="!form['image'+i]"
                                    class="material-icons text-slate-300 text-2xl group-hover:scale-110 transition-transform">add_a_photo</span>
                            </div>
                            <div class="flex-1">
                                <label
                                    class="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1.5 block">Image
                                    {{i}} URL</label>
                                <input type="text" [(ngModel)]="form['image'+i]" placeholder="Paste URL here..."
                                    class="w-full h-11 px-4 bg-slate-50 border border-slate-100 rounded-xl text-[11px] font-mono focus:bg-white transition-all outline-none">
                            </div>
                        </div>
                    </div>

                    <div class="p-4 bg-amber-50 rounded-2xl border border-amber-100/50 mt-4">
                        <div class="flex items-center gap-3 text-amber-600">
                            <span class="material-icons text-lg">info</span>
                            <p class="text-[10px] font-bold leading-relaxed">
                                สามารถใช้ URL รูปภาพภายนอกได้
                                ระบบจะจัดเก็บเป็นลิงค์อ้างอิงเพื่อประหยัดพื้นที่จัดเก็บข้อมูลของเซิร์ฟเวอร์
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>